module.exports = __webpack_public_path__ + "img/bim4.cd9a5a6d.png";